<template>
    <div>
        <hero-bar :has-right-visible="true" menu-icon="desktop-mac">
            {{ $lang.Calculation.Title }}
            <span class="subtitle hero-subtitle">{{ $lang.Calculation.NewTitle_3 }}</span>

            <p class="control" slot="right" style="margin-right: 16px">
                <b-button class="button is-catalog-request" icon-left="plus-box-outline" @click="openCircuitDevices">{{ [$lang.Calculation.InnerTitle_14, $lang.Calculation.InnerTitle_15, $lang.Calculation.InnerTitle_16].join(' ') }}</b-button>
            </p>
            <p class="control" slot="right" style="margin-right: 16px">
                <b-button class="button is-gray" @click="previous">{{ $lang.Menus.BackBtn }}</b-button>
            </p>
            <p class="control" slot="right">
                <b-button class="button is-primary" @click="submit">{{ $lang.Menus.ContinueBtn }}</b-button>
            </p>
        </hero-bar>

        <div class="wizard">
            <div class="wizard-rail">
                <verticalStep-bar />
            </div>

            <div class="wizard-body calc-body">
                <calculationTabs />
                <outputCircBtns />

                <!-- Add a busbar: what the user picks, then what follows from it (greyed). -->
                <div class="wizard-card">
                    <p class="wizard-card-head">{{ $lang.CalcCircInfos.Title_3 }}</p>
                    <div class="calc-grid">
                        <b-field :label="$lang.CalcCircInfos.TableDefinition">
                            <b-input v-model="definition_1"></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.BusbarDimension" :type="{ 'is-danger': hasError_SelectedBusbarDimension_1 }" :message="emptyWarning_SelectedBusbarDimension_1">
                            <b-select v-model="selectedBusbarDimension_1" expanded @input="getBusbarCalculationDevice">
                                <option v-for="option in busbarDimensionList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorLength" :type="{ 'is-danger': hasError_ConductorLength_1 }" :message="emptyWarning_ConductorLength_1">
                            <b-input v-model="conductorLength_1" step="any" @input="setPositiveNumber()"></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorTemp">
                            <b-input v-model="conductorTemp" type="number" disabled></b-input>
                        </b-field>
                        <b-field>
                            <template #label><span v-html="$lang.CalcCircInfos.Tmax_inPanel"></span></template>
                            <b-input v-model="Tmax_inPanel" type="number" disabled></b-input>
                        </b-field>
                        <b-field>
                            <template #label><span v-html="$lang.CalcCircInfos.Imax"></span></template>
                            <b-input v-model="Imax_1" type="number" disabled></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.PhaseNumber">
                            <b-input v-model="phaseNumber_1" type="number" disabled></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.LostPower">
                            <b-input v-model="lostPower_1" type="number" disabled></b-input>
                        </b-field>
                    </div>
                    <div class="calc-actions">
                        <b-button type="is-success" :label="$lang.CalcCircInfos.CalcAddButton" @click="addToBusbarCalculationDevices" />
                    </div>
                </div>

                <template v-if="busbardevicesdata.length != 0">
                    <p class="wizard-card-head">{{ $lang.CalcCircInfos.Title_7 }}</p>
                    <div class="calc-table-card">
                        <b-table class="data-table is-flush" style="--table-min: 940px" :data="busbardevicesdata">
                            <b-table-column field="Definition" :label="$lang.CalcCircInfos.TableDefinition" v-slot="props" cell-class="cell-strong">
                                {{ props.row.Definition }}
                            </b-table-column>
                            <b-table-column field="Width_Thickness" :label="$lang.CalcCircInfos.BusbarDimension" v-slot="props" width="96">
                                {{ props.row.Width_Thickness }}
                            </b-table-column>
                            <b-table-column field="ConductorTemperature" :label="$lang.CalcCircInfos.ConductorTemp" v-slot="props" width="84" numeric>
                                {{ props.row.ConductorTemperature }}
                            </b-table-column>
                            <b-table-column field="MaxTemperature" width="112" numeric>
                                <template v-slot:header=""><span v-html="$lang.CalcCircInfos.Tmax_inPanel"></span></template>
                                <template v-slot="props">{{ props.row.MaxTemperature }}</template>
                            </b-table-column>
                            <b-table-column field="I_Max" width="72" numeric>
                                <template v-slot:header=""><span v-html="$lang.CalcCircInfos.Imax"></span></template>
                                <template v-slot="props">{{ truncate(props.row.I_Max, 1) }}</template>
                            </b-table-column>
                            <b-table-column field="ConductorLength" :label="$lang.CalcCircInfos.ConductorLength" v-slot="props" width="96" numeric>
                                {{ props.row.ConductorLength }}
                            </b-table-column>
                            <b-table-column field="PhasesNumber" :label="$lang.CalcCircInfos.PhaseNumber" v-slot="props" width="64" numeric>
                                {{ props.row.PhasesNumber }}
                            </b-table-column>
                            <b-table-column field="LostPower" :label="$lang.CalcCircInfos.LostPower" v-slot="props" width="84" numeric>
                                {{ truncate(props.row.LostPower, 1) }}
                            </b-table-column>
                            <b-table-column field="CalcResult" width="84" numeric>
                                <template v-slot:header=""><span v-html="$lang.CalcCircInfos.CalcResult"></span></template>
                                <template v-slot="props">{{ truncate(props.row.CalcResult, 1) }}</template>
                            </b-table-column>
                            <b-table-column field="Action" v-slot="props" width="158">
                                <div class="row-actions">
                                    <button class="button row-action" :title="$lang.MyProjects.Edit" @click="openUpdateBusbarDeviceModal(props.row)">
                                        <span class="mdi mdi-pencil" aria-hidden="true"></span>
                                    </button>
                                    <button class="button row-action is-destructive" :title="$lang.MyProjects.Delete" @click="deleteFromBusbarCalculationDevices(props.row)">
                                        <span class="mdi mdi-delete" aria-hidden="true"></span>
                                    </button>
                                    <button class="button row-action" :title="$lang.MyProjects.Copy" @click="copyFromBusbarCalculationDevices(props.row)">
                                        <span class="mdi mdi-content-copy" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </b-table-column>
                        </b-table>
                        <div class="calc-total">
                            <span>{{ $lang.CalcCircInfos.Total_P_Busbar }}</span>
                            <b>{{ truncate(total_P_Busbar, 1) }}</b>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <!-- Edit a busbar. It shares the add form's fields; the form is kept and given back. -->
        <b-modal v-model="isBusbarDeviceUpdateModalActive" has-modal-card :width="720" @close="restoreForm">
            <div class="modal-card calc-modal">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ $lang.CalcCircInfos.UpdateBusbar }}</p>
                </header>
                <section class="modal-card-body">
                    <div class="calc-grid is-two">
                        <b-field :label="$lang.CalcCircInfos.TableDefinition">
                            <b-input v-model="definition_1"></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.BusbarDimension" :type="{ 'is-danger': hasError_SelectedBusbarDimension_1 }" :message="emptyWarning_SelectedBusbarDimension_1">
                            <b-select v-model="selectedBusbarDimension_1" expanded @input="getBusbarCalculationDevice">
                                <option v-for="option in busbarDimensionList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorLength" :type="{ 'is-danger': hasError_ConductorLength_1 }" :message="emptyWarning_ConductorLength_1">
                            <b-input v-model="conductorLength_1" step="any" @input="setPositiveNumber()"></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorTemp">
                            <b-input v-model="conductorTemp" type="number" disabled></b-input>
                        </b-field>
                        <b-field>
                            <template #label><span v-html="$lang.CalcCircInfos.Tmax_inPanel"></span></template>
                            <b-input v-model="Tmax_inPanel" type="number" disabled></b-input>
                        </b-field>
                        <b-field>
                            <template #label><span v-html="$lang.CalcCircInfos.Imax"></span></template>
                            <b-input v-model="Imax_1" type="number" disabled></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.PhaseNumber">
                            <b-input v-model="phaseNumber_1" type="number" disabled></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.LostPower">
                            <b-input v-model="lostPower_1" type="number" disabled></b-input>
                        </b-field>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <b-button :label="$lang.Menus.ModalCloseBtn" @click="closeUpdateModal" />
                    <b-button :label="$lang.Menus.ModalUpdtBtn" type="is-primary" @click="updateBusbarCalculationDevice()" />
                </footer>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';
    import { storeLossTotals } from '@/api/lossTotals';
    import VerticalStepBar from '@/components/VerticalStepBar.vue';
    import OutputCircBtns from '@/components/OutputCircBtns.vue';
    import CalculationTabs from '@/components/CalculationTabs.vue';
    import keepFormDuringEdit from '@/mixins/keepFormDuringEdit';

    const DIGIT_EXPRESSION = /^\d$/;

    const isDigit = (character) => {
        return character && DIGIT_EXPRESSION.test(character);
    };

    export default {
        name: 'Calc_Busbar',
        mixins: [keepFormDuringEdit],
        components: {
            VerticalStepBar,
            OutputCircBtns,
            CalculationTabs
        },
        data() {
            return {
                isActive: true,
                labelPosition: 'on-border',
                projectId: 0,
                currentPage: 1,
                busbardevicesdata: [],
                total_P_Busbar: 0,

                busbarCalcDeviceId: 0,
                definition_1: this.$lang.Calculation.Busbar,
                definitionIndex_1: 0,
                busbarDimensionList: [],
                selectedBusbarDimension_1: '',
                conductorTemp: 70,
                Tmax_inPanel: 0,
                Imax_1: 0,
                conductorLength_1: 1,
                phaseNumber_1: 3,
                lostPower_1: 0,
                isBusbarDeviceUpdateModalActive: false,
                hasError_SelectedBusbarDimension_1: false,
                emptyWarning_SelectedBusbarDimension_1: '',
                hasError_ConductorLength_1: false,
                emptyWarning_ConductorLength_1: '',
                canCalculate_1: false,
            }
        },
        mounted() {
            this.projectId = this.$store.state.projectId;
            this.Tmax_inPanel = this.$store.state.maxTemperature;

            this.getBusbarDevicesTable();
            this.getBusbarDimensions();
            this.$store.state.activeStep = 3;
            this.$store.state.isFooterFixed = false;
        },
        watch: {
            $route() {

            }
        },
        methods: {
            previous() {
                this.$store.isPageOpenedFromStepBar = false;

                // Back to Kayıp Güç, the step this tool belongs to; it went to Çevresel Koşullar.
                router.push('/calculation');
            },
            submit() {
                this.saveResult();

                this.$store.isPageOpenedFromStepBar = false;
                this.$store.canResultOpen = true;

                router.push('/calc_InputCircuit');
            },
            // The whole tool's total, from the server: see api/lossTotals.js.
            saveResult() {
                return storeLossTotals(this.$store, this.projectId).catch(() => {});
            },
            resetBusbarDevice() {
                this.selectedBusbarDimension_1 = '';
                this.conductorTemp = 70;
                this.Imax_1 = 0;
                this.conductorLength_1 = 1;
                this.phaseNumber_1 = 3;
                this.lostPower_1 = 0;
                this.isBusbarDeviceUpdateModalActive = false;
            },
            getTotal_P_BusbarCalculationDevices() {
                api.panels.getTotal_P_BusbarCalculationDevices(this.projectId).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        this.total_P_Busbar = res.data;
                        this.saveResult();
                    }
                });
            },
            getBusbarDevicesTable() {
                this.busbardevicesdata = [];
                api.panels.getBusbarCalculationDevices(this.projectId).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        var digitList = [];
                        res.data.forEach((e) => {
                            this.busbardevicesdata.push(e);

                            var last = e.Definition.charAt(e.Definition.length - 1);
                            if (isDigit(last)) {
                                digitList.push(parseInt(last));
                            }
                        });
                        this.getTotal_P_BusbarCalculationDevices();

                        var maxDigit = 0;
                        for (let i = 0; i < digitList.length; i++) {
                            if (maxDigit < digitList[i]) {
                                maxDigit = digitList[i];
                            }
                        }
                        this.definitionIndex_1 = maxDigit + 1;
                        this.definition_1 = this.$lang.Calculation.Busbar + " " + this.definitionIndex_1;
                    }
                });
            },
            addToBusbarCalculationDevices() {
                this.controlInputs();

                if (this.canCalculate_1) {
                    const device = {
                        ProjectId: this.projectId,
                        Definition: this.definition_1,
                        Width_Thickness: this.selectedBusbarDimension_1,
                        ConductorTemperature: this.conductorTemp,
                        MaxTemperature: this.Tmax_inPanel,
                        I_Max: this.Imax_1,
                        ConductorLength: this.conductorLength_1,
                        PhasesNumber: this.phaseNumber_1,
                        LostPower: this.lostPower_1,
                    };

                    api.panels.addToBusbarCalculationDevices(device).then((res) => {
                        if (res.isError) {
                            this.$buefy.dialog.alert(this.$errorModal(res));
                        } else {
                            this.$buefy.toast.open(this.$lang.OtherDialog.Added);
                            this.getBusbarDevicesTable();
                            this.resetBusbarDevice();
                        }
                    });
                }
            },
            deleteFromBusbarCalculationDevices(device) {
                this.$buefy.dialog.confirm({
                    title: this.$lang.DeleteDialog.Title,
                    message: this.$lang.DeleteDialog.Message,
                    confirmText: this.$lang.DeleteDialog.Confirm,
                    cancelText: this.$lang.DeleteDialog.Cancel,
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () =>

                        api.panels.deleteFromBusbarCalculationDevices(device).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                this.$buefy.toast.open(this.$lang.DeleteDialog.Deleted);
                                this.getBusbarDevicesTable();
                            }
                        })
                })
            },
            copyFromBusbarCalculationDevices(device) {
                var initialDefinition = device.Definition;
                device.Definition = device.Definition + " " + this.$lang.CopyDialog.Extension;
                this.$buefy.dialog.confirm({
                    title: this.$lang.CopyDialog.Title,
                    message: this.$lang.CopyDialog.Message,
                    confirmText: this.$lang.CopyDialog.Confirm,
                    cancelText: this.$lang.CopyDialog.Cancel,
                    type: 'is-warning',
                    hasIcon: true,
                    onConfirm: () =>

                        api.panels.addToBusbarCalculationDevices(device).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                this.$buefy.toast.open(this.$lang.CopyDialog.Copied);
                                this.getBusbarDevicesTable();
                            }
                        }),
                    onCancel: () => {
                        device.Definition = initialDefinition;
                    }
                })
            },
            openUpdateBusbarDeviceModal(device) {
                this.keepForm(['definition_1', 'selectedBusbarDimension_1', 'Imax_1', 'conductorLength_1', 'phaseNumber_1', 'lostPower_1', 'hasError_SelectedBusbarDimension_1', 'emptyWarning_SelectedBusbarDimension_1', 'hasError_ConductorLength_1', 'emptyWarning_ConductorLength_1']);
                this.busbarCalcDeviceId = device.Id;
                this.isBusbarDeviceUpdateModalActive = true;
                this.definition_1 = device.Definition;
                this.selectedBusbarDimension_1 = device.Width_Thickness;
                this.Imax_1 = device.I_Max;
                this.conductorLength_1 = device.ConductorLength;
                this.phaseNumber_1 = device.PhasesNumber;
                this.lostPower_1 = device.LostPower;
            },
            closeUpdateModal() {
                this.isBusbarDeviceUpdateModalActive = false;
                this.restoreForm();
            },
            updateBusbarCalculationDevice() {
                // The same checks as an add; the dialog used to save whatever it held.
                this.controlInputs();
                if (!this.canCalculate_1) {
                    return;
                }
                const device = {
                    Id: this.busbarCalcDeviceId,
                    ProjectId: this.projectId,
                    Definition: this.definition_1,
                    Width_Thickness: this.selectedBusbarDimension_1,
                    ConductorTemperature: this.conductorTemp,
                    MaxTemperature: this.Tmax_inPanel,
                    I_Max: this.Imax_1,
                    ConductorLength: this.conductorLength_1,
                    PhasesNumber: this.phaseNumber_1,
                    LostPower: this.lostPower_1,
                };

                api.panels.updateBusbarCalculationDevice(device).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        this.closeUpdateModal();
                        this.$buefy.toast.open(this.$lang.OtherDialog.Updated);
                        this.getBusbarDevicesTable();
                    }
                });
            },
            getBusbarDimensions() {
                this.busbarDimensionList = [];
                api.panels.getBusbarDimensions().then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.busbarDimensionList.push(e);
                        });
                    }
                });
            },
            getBusbarCalculationDevice() {
                var busbarIndex = this.busbarDimensionList.indexOf(this.selectedBusbarDimension_1) + 1;
                api.panels.getBusbarCalculationDevice(busbarIndex, this.Tmax_inPanel).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        this.Imax_1 = res.data.I_Max;
                        this.lostPower_1 = res.data.LostPower;
                    }
                });
            },
            truncate(numToBeTruncated, numOfDecimals) {
                var theNumber = numToBeTruncated.toString();
                if (theNumber.includes('.')) {
                    var pointIndex = theNumber.indexOf('.');
                    var _result = +(theNumber.slice(0, pointIndex > -1 ? ++numOfDecimals + pointIndex : undefined));
                    var _resultString = _result.toString();
                    if (!_resultString.includes('.')) {
                        return _resultString + '.0';
                    } else {
                        return _result;
                    }
                } else {
                    return theNumber + '.0';
                }
            },
            columnTdAttrs(row, column) {
                if (row.id === 'Total') {
                    if (column.label === 'ID') {
                        return {
                            colspan: 4,
                            class: 'has-text-weight-bold',
                            style: {
                                'text-align': 'left !important'
                            }
                        }
                    } else if (column.label === 'Gender') {
                        return {
                            class: 'has-text-weight-semibold'
                        }
                    } else {
                        return {
                            style: { display: 'none' }
                        }
                    }
                }
                return null
            },
            controlInputs() {
                // Cleared on every check: it used to stay true after the first good add, so a
                // later add with empty fields went through.
                this.canCalculate_1 = false;
                if (this.selectedBusbarDimension_1 == '') {
                    this.hasError_SelectedBusbarDimension_1 = true;
                    this.emptyWarning_SelectedBusbarDimension_1 = this.$lang.Menus.EmptyWarning;
                } else if (!(parseFloat(this.conductorLength_1) > 0)) {
                    this.hasError_ConductorLength_1 = true;
                    this.emptyWarning_ConductorLength_1 = this.conductorLength_1 === '' ? this.$lang.Menus.EmptyWarning : this.$lang.Menus.PositiveWarning;
                } else {
                    this.canCalculate_1 = true;
                }

                if (this.selectedBusbarDimension_1 != '') {
                    this.hasError_SelectedBusbarDimension_1 = false;
                    this.emptyWarning_SelectedBusbarDimension_1 = '';
                }
                if (parseFloat(this.conductorLength_1) > 0) {
                    this.hasError_ConductorLength_1 = false;
                    this.emptyWarning_ConductorLength_1 = '';
                }
            },
            openCircuitDevices() {
                this.$store.state.previousRoute = this.$route.name;
                this.$store.state.isCircDevicesFromCalculation = true;
                if (this.$store.state.isAdmin == 1) {
                    router.push('/circuitDevices_Admin');
                } else {
                    router.push('/circuitDevices');
                }
            },
            setPositiveNumber() {
                if (this.conductorLength_1) {
                    this.conductorLength_1 = parseFloat(this.conductorLength_1.toString().replace(',', '.'));
                }

                if (this.conductorLength_3) {
                    this.conductorLength_3 = parseFloat(this.conductorLength_3.toString().replace(',', '.'));
                }
            },
        }
    };
</script>
